import { makeAutoObservable } from 'mobx';
import { TradeImportLogDto } from '../../../../defs/api';

export class TradeImportLogMobxDto implements TradeImportLogDto {
    id: string;

    date: Date;

    tradesCount: number;

    reverted: boolean;

    importerName: string;

    portfolioId: string;

    constructor() {
        makeAutoObservable(this);
    }

    static create(dto: TradeImportLogDto): TradeImportLogMobxDto {
        const mobxDto = new TradeImportLogMobxDto();
        return Object.assign(mobxDto, dto);
    }

    static createFromArray(dtos: TradeImportLogDto[]): TradeImportLogMobxDto[] {
        return dtos.map((dto) => TradeImportLogMobxDto.create(dto));
    }
}
